import { render, staticRenderFns } from "./BusinessCards.vue?vue&type=template&id=036dac2e"
import script from "./BusinessCards.vue?vue&type=script&lang=js"
export * from "./BusinessCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports